// extracted by mini-css-extract-plugin
export var animationContainer = "_ix-0";
export var asteriskIcon = "_ix-8";
export var conversationLeftSection = "_ix-4";
export var conversationListItem = "_ix-3";
export var conversationMiddleSection = "_ix-5";
export var conversationRightSection = "_ix-6";
export var detailsContent = "_ix-1";
export var listContainer = "_ix-7";
export var modalContent = "_ix-2";